import styled from 'styled-components';
import { FaPhoneSquareAlt as FA, FaViber as FV, FaWhatsapp as FW } from 'react-icons/fa';

export const ContactPage = styled.div`
  width: 100%;
  background: #282828;
  padding: clamp(20px, 4vw, 50px) clamp(16px, 5vw, 64px) clamp(40px, 6vw, 72px);
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(250px, 0.8fr) minmax(300px, 1.05fr);
  gap: clamp(20px, 3vw, 44px);
  align-items: center;

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
export const ContactHeader = styled.span`
  width: 100%;
  grid-column: 1 / -1;
  margin: 10px 0;
  font-size: clamp(1.6rem, 4vw, 2rem);
  color: #dfdfdf;
  font-weight: 500;
  text-align: center;
  @media screen and (max-width: 960px) {
  }
`;

export const ContactMap = styled.div`
  border-radius: 5px;
  width: 100%;
  overflow: hidden;
`;

export const MapPlaceholder = styled.div`
  min-height: 300px;
  padding: 28px;
  border: 1px solid #5c665f;
  border-radius: 5px;
  background: #1f1f1f;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  justify-content: center;
  text-align: center;

  button {
    padding: 10px 16px;
    border: 1px solid #fff;
    border-radius: 5px;
    background: #00933b;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
  }
`;

export const ContactAdress = styled.div`
  padding: clamp(10px, 2vw, 24px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
`;
export const ContactHead = styled.span`
  font-weight: 600;
  font-size: 22px;
  margin: 10px;
`;

export const ContactBody = styled.span`
  font-weight: 400;
  font-size: 18px;
`;
export const ContactPhone = styled.a`
  vertical-align: middle;
  font-weight: 500;
  text-decoration: none;
  color: white;
  justify-content: center;
  text-align: center;
  font-size: clamp(18px, 2vw, 24px);
  margin-top: 20px;
  display: flex;
  align-items: center;
  transition: 0.4s ease;

  &:hover {
    color: #ff6800;
  }
`;
export const ContactMail = styled.a`
  vertical-align: middle;
  font-weight: 500;
  text-decoration: none;
  color: white;
  justify-content: center;
  text-align: center;
  font-size: clamp(17px, 1.7vw, 20px);
  white-space: nowrap;
  gap: 8px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  transition: 0.4s ease;
  &:hover {
    color: #ff6800;
  }
`;

export const FaPhoneSquareAlt = styled(FA)``;

export const FaViber = styled(FV)``;

export const FaWhatsapp = styled(FW)``;

export const WriteHeader = styled.span`
  font-size: 28px;
  font-weight: 600;
  color: white;
  border-bottom: 1px solid grey;
  margin: 10px;
`;

export const ContactWrite = styled.div`
  flex-direction: column;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 701px) and (max-width: 1100px) {
    grid-column: 1 / -1;
    width: min(100%, 620px);
    justify-self: center;
  }
`;

export const PrivacyNotice = styled.p`
  width: 100%;
  color: #e5e5e5;
  font-size: 13px;
  line-height: 1.5;

  a {
    color: #9ee8bc;
  }
`;

export const FormStatus = styled.p`
  width: 100%;
  padding: 9px 12px;
  border-radius: 4px;
  background: ${(props) => (props.$error ? '#6b1f1f' : '#145a2f')};
  color: #fff;
  line-height: 1.4;
`;
